import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faPlus } from "@fortawesome/free-solid-svg-icons";
import cc from "currency-codes";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { fetchUserDetails } from "../../utils/auth";
import Header from "../Header";
import Footer from "../Footer";
import UserPosts from "../Posts/UserPosts";

const Base_Url = process.env.REACT_APP_BASE_URL;

const countries = cc.countries().map((name) => ({
  value: name,
  label: name,
}));

const UserDetails = () => {
  const location = useLocation();
  const [userDetails, setUserDetails] = useState({
    id: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    country: "",
    bankDetails: {
      accountNumber: "",
      ifscCode: "",
      bankName: "",
      bankAddress: "",
      swiftCode: "",
      accountHolderName: "",
      transitCode: "",
      institutionNumber: "",
    },
    eTranferEmail: "",
    paypalEmail: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  useEffect(() => {
    fetchUserDetails(setUserDetails, navigate, setProfilePhoto, countries);
  }, [navigate]);

  const calculateCompleteness = () => {
    let completedFields = 0;
    const totalFields = 6;
    if (userDetails.firstName) completedFields++;
    if (userDetails.lastName) completedFields++;
    if (userDetails.email) completedFields++;
    if (userDetails.password) completedFields++;
    if (userDetails.country) completedFields++;
    if (profilePhoto) completedFields++;
    return (completedFields / totalFields) * 100;
  };

  const handleEditButtonClick = () => {
    if (userDetails && userDetails.id) {
      navigate(`/edit/user/${userDetails.id}`);
    }
  };
  return (
    <>
      <Header />
      <div className="below-header">
        <p>
          <NavLink to={"/"}>Home</NavLink>
          <span>/</span>
          <a href={location.pathname} className="aCustom">My Profile</a>
        </p>
      </div>
      <div className="user-details-container">
        <div className="profile-container">
          <div className="profile-photo-container">
            <p>Profile Photo</p>
            <div className="profile-photo">
              {profilePhoto ? (
                <img
                  src={`${Base_Url}/assets/profilePhotos/${profilePhoto}`}
                  alt="Profile"
                />
              ) : (
                <FontAwesomeIcon icon={faPlus} />
              )}
            </div>
          </div>
          {role !== "admin" && (
            <div className="progress-container">
              <div className="profile-progress">
                <h2>Profile Completion</h2>
                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${calculateCompleteness()}%` }}
                  ></div>
                </div>
                <p>{Math.round(calculateCompleteness())}% Complete</p>
              </div>
            </div>
          )}
        </div>
        <div className="details-container">
          <div className="contact-details">
            <div className="edit-btn-container">
              <button
                type="button"
                className="editBtn"
                onClick={handleEditButtonClick}
              >
                Edit
              </button>
            </div>
            <h2>Contact Details</h2>
            <div className="input-group">
              <input
                type="text"
                name="firstName"
                value={userDetails.firstName}
                disabled
                placeholder="First Name"
              />
              <input
                type="text"
                name="lastName"
                value={userDetails.lastName}
                disabled
                placeholder="Last Name"
              />
            </div>
            <div className="input-group">
              <input
                className="emailInput"
                type="email"
                name="email"
                value={userDetails.email}
                disabled
                placeholder="Email"
              />
              <div className="edit-password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={userDetails.password}
                  disabled
                  placeholder="Password"
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  className="password-icon"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>
            <Select
              className="country-select"
              options={countries}
              value={userDetails.country}
              isDisabled
              placeholder="Country"
            />
          </div>
          {role !== "admin" && (
            <div className="bank-details">
              <h2>Bank Details</h2>
              <div className="input-group">
                <input
                  type="text"
                  name="accountNumber"
                  value={userDetails.bankDetails?.accountNumber}
                  disabled
                  placeholder="Account Number"
                />
                <input
                  type="text"
                  name="accountHolderName"
                  value={userDetails.bankDetails?.accountHolderName}
                  disabled
                  placeholder="Account Holder Name"
                />
              </div>

              <div className="input-group">
                <input
                  type="text"
                  name="bankName"
                  value={userDetails.bankDetails?.bankName}
                  disabled
                  placeholder="Bank Name"
                />
                <input
                  type="text"
                  name="bankAddress"
                  value={userDetails.bankDetails?.bankAddress}
                  disabled
                  placeholder="Bank Address"
                />
              </div>

              <div className="input-group">
                <input
                  type="text"
                  name="ifscCode"
                  value={userDetails.bankDetails?.ifscCode}
                  disabled
                  placeholder="IFSC Code"
                />
                <input
                  type="text"
                  name="swiftCode"
                  value={userDetails.bankDetails?.swiftCode}
                  disabled
                  placeholder="SWIFT Code"
                />
              </div>
              <div className="input-group">
                <input
                  type="text"
                  name="Transit code"
                  value={userDetails.bankDetails?.transitCode}
                  disabled
                  placeholder="Transit code"
                />
                <input
                  type="text"
                  name="Institution number"
                  value={userDetails.bankDetails?.institutionNumber}
                  disabled
                  placeholder="Institution number"
                />
              </div>

              {(userDetails?.eTranferEmail || userDetails?.paypalEmail) && (
                <div className="contact-dynamic-details2">
                  {userDetails?.eTranferEmail && (
                    <div className="contact-inner-details">
                      <h2>E-Transfer Details</h2>
                      <div className="input-groupp">
                        <input
                          className="emailInput"
                          type="email"
                          name="eTranferEmail"
                          value={userDetails.eTranferEmail}
                          disabled
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  )}
                  {userDetails?.paypalEmail && (
                    <div className="contact-inner-details">
                      <h2>PayPal Details</h2>
                      <div className="input-group">
                        <input
                          className="emailInput"
                          type="email"
                          name="paypalEmail"
                          value={userDetails.paypalEmail}
                          disabled
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          <div className="user-all-posts">
            <h2>Posts</h2>
            <UserPosts view={"profile"} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserDetails;
